
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import banner from '../pics/banner.PNG';
import Select from 'react-select';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import About from '../About/About';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAllCustomerOrders, getOrderStatuses, getAllOrderStatuses, formatDate } from '../Utils/Utils';
import { Ordertable } from '../Ordertable/Ordertable';
import { LoadingPage } from '../Loadingpage/Loadingpage';
import { LayoutDashboard, Menu } from 'lucide-react';
class Orders extends React.Component {
    constructor(props) {
        super(props);
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            servicedate: new Date(),
            mycomments: '',
            loadweights: '',
            mobilePhone: '',
            address: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            token: "",
            role: "",
            address: "",
            gender: "",
            city: "",
            area: "",
            userid: "",
            allCustomerOrders: [],
            allorderstatuses: [],
            orderCount: 0,
            page: 'allOrders',
            lastorderstatus: '',
            searchTerm: '',
            isLoading: true,
            dashboardtype: ''
        }
    }
    orderstats = []
    strStat = ''

    componentDidMount = async () => {

        let strOrders = await getAllCustomerOrders(this.props.location.state.userid);

        this.setState({ isLoading: false });
        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, gender: this.props.location.state.gender,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, allCustomerOrders: await getAllCustomerOrders(), allorderstatuses: await getAllOrderStatuses()
            })
            if (strOrders.includes('no data')) {
                this.setState({ orderCount: 0 });
            }
            else {
                this.setState({ orderCount: strOrders.length });
            }

            if (this.props.location.state.dashboardOrderType !== undefined) {
                this.setState({
                    allCustomerOrders: this.props.location.state.dashboardOrderType, orderCount: this.props.location.state.dashboardOrderType.length,
                    dashboardtype: this.props.location.state.dashboardtype
                })
            }


            //  console.log(strOrders);
        }

    }

    getLastOrderStatus = (orderid) => {
        let lastStatus = 'Submitted'
        if ((this.state.allorderstatuses.length !== 0) && (Array.isArray(this.state.allorderstatuses))) {
            for (let i = 0; i < this.state.allorderstatuses.length; i++) {
                if (this.state.allorderstatuses[i].orderid === orderid) {
                    lastStatus = this.state.allorderstatuses[i].status
                    break
                }
            }
            //  console.log(this.state.allorderstatuses)                        
        }
        return lastStatus
    }

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, gender: this.props.location.state.gender,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address: this.props.location.state.address,
                area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid, gender: this.props.location.state.gender
            }
        });
    }
    setSearchTerm = (e) => {

        if (e.target.value.trimEnd() === '' || e.target.value.trimStart() === '') {
            this.componentDidMount();
            return;
        }
        const searchResult = this.state.allCustomerOrders.filter(order => {
            return order.id.includes(e.target.value.trimStart()) || order.fullname.toLowerCase().includes(e.target.value.toLowerCase());
        });
        // searchResult.sort((a, b) => new Date(b.servicedate) - new Date(a.servicedate));    
        this.setState({ searchTerm: e.target.value, allCustomerOrders: searchResult });
    }

    clearSearchTerm = (e) => {
        if (e.key === 'Backspace' && this.state.searchTerm.length === 1) {
            this.setState({ searchTerm: '' });
            this.componentDidMount();
        }
    }
    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        // console.log(this.props.location.state);
        return (
            <>
                <div style={{ height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px", fontFamily:"lora" }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid #f0eee4', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "5px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold", textShadow: "2px 2px 4px #000000" }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>Logged in as {(this.state.fullname).split(" ")[0]} </label></span><br /> */}
                            <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span>
                        </div>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "1vh" }}>
                        <label variant="primary" style={{
                            border: "none",
                            paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "100%", borderRadius: "10px",
                        }} onClick={this.goBackToMenu}>
                            <span style={{
                                textAlign: "center", fontStyle: "italic", color: "darkblue",
                                fontWeight: "bold", textShadow: "1px 1px 2px grey"
                            }}><ArrowLeft color="darkblue" size={40} /> ALL {this.state.dashboardtype} ORDERS</span>
                        </label>
                    </div>
                    {this.state.isLoading ? (
                        <LoadingPage />
                    ) : (
                        <>
                            <div style={{ paddingTop: "10px", fontSize: "15px" }}>
                                <FormGroup>
                                    <FaSearch size={20} style={{ position: "absolute", marginLeft: "90%", marginTop: "10px" }} />
                                    <Input
                                        style={{height: '50px', borderBottom: "2px solid darkblue", borderRadius: "10px", backgroundColor: "#f0eee4", fontStyle: "italic", color: "#666" }}
                                        type='text'
                                        id='searchOrders'
                                        placeholder='Search by orderID or by name'
                                        onChange={this.setSearchTerm}
                                        onKeyDown={this.clearSearchTerm}
                                        title='Clear search box to reset'
                                    />
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px", overflow: "auto", fontSize:"18px" }}>
                                <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
                                    <span className="" style={{ color: "darkblue", fontStyle: "italic" }}><h5>Order count: {this.state.orderCount}</h5></span>
                                </div>

                                <div style={{ border: "2px solid lightgrey", borderRadius: "10px", paddingbottom: "20px" }}>
                                    {/* Call the new component here */}
                                    <Ordertable data={this.state.allCustomerOrders}
                                        laststatus={this.getLastOrderStatus}
                                        navigation={(orderid) => this.props.navigate('/orderdetails', {
                                            state: {
                                                orderid: orderid, fullname: this.state.fullname, emailaddress: this.state.emailaddress, gender: this.state.gender,
                                                userid: this.state.userid, phonenumber: this.state.phonenumber, role: this.state.role, address:
                                                    this.state.address, area: this.state.area, city: this.state.city, page: this.state.page, gender: this.state.gender
                                            }

                                        })} />
                                </div>
                            </div>
                        </>
                    )
                    }

                    <div style={{
                        borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                        backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "10px", paddingBottom: "10px"
                    }}>
                        <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                        <div>
                            <Button style={{
                                backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                fontWeight: "bold", textDecoration: "underline"
                            }}
                                onClick={this.openAbout}>About Us
                            </Button>
                            | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>
                        </div>
                    </div>

                    <div>
                        <About
                            ref={this.handleAboutOpen}
                            onAboutClose={this.onAboutClose}
                        />
                    </div>
                </div>
            </>
        );
    }
}
export default withNavigateHook(Orders);
